module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Aqmhq"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 16: Begin Again"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pAhd-"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch17",
      "id": "AB_cha17"
    }
  }, [_vm._v("JANUARY 16"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2a"
  }, [_vm._v("Begin Again")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pAqvq"
    }
  }, [_c('em', [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" is the one who goes ahead of you; He will be with you. He will not fail you or forsake you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pAdDx"
    }
  }, [_vm._v("—Deuteronomy 31:8 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NASB")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "AKlY"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("A")])]), _vm._v("t the beginning of each year, many people resolve to make life changes. After the clock strikes midnight, New Year’s resolutions are under way. These resolutions take many forms: exercise more, eat less ice cream, run a marathon, prioritize rest, get out of debt, cross something off the bucket list, spend more time with family.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAlPO"
    }
  }, [_vm._v("At first you’re focused, excited, and determined. But then someone brings donuts to the meeting, work demands more of your time, extra money goes toward a new roof—and what was once a seemingly achievable goal becomes more of a fantasy. After a couple of weeks, your enthusiasm begins to fizzle, and by February you decide to try again next year.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAXPk"
    }
  }, [_vm._v("Isn’t it wonderful to know that God never gives up on us? Even when we slip and stumble and make mistakes, and even if we wonder if we’ll ever change, He cheers us on. He gives us a new beginning any time we need it. In His eyes, every moment is January 1st! Remember that when you rise in the morning: there’s a fresh start with each day.")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pA-e6"
    }
  }, [_c('em', [_vm._v("God, thank You for every time You offer me a January 1. I may need one today!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b562fe66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter17.vue
// module id = 117
// module chunks = 0